import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { environment } from 'src/environments/environment';
import { UserService } from '../services/user/user.service';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class QrCodeGuard {
  constructor(
    readonly router: Router,
    private userService: UserService,
  ) {}

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const id = route.params['id'];

    const caminhosIntencionais = environment.redirect.caminhosIntencionais; // Token Caminhos Intencionais
    const caminhosIntencionaisQRCode = environment.redirect.caminhosIntencionaisQRCode; // Token Caminhos Intencionais - QRCode

    const tokens: { [key: string]: string } = {
      [caminhosIntencionais.hash]: caminhosIntencionais.link, // Token Caminhos Intencionais
      [caminhosIntencionaisQRCode.hash]: caminhosIntencionaisQRCode.link, // Token Caminhos Intencionais - QRCode
    };

    // Se o token não existir na lista, redireciona para login
    if (!tokens[id]) {
      await this.router.navigate(['/login']);
      return false;
    }

    // Tenta obter o token criptografado
    try {
      const encryptedToken = await lastValueFrom(this.userService.encryptToken());

      if (encryptedToken) {
        window.location.assign(`${tokens[id]}?token=${encodeURIComponent(encryptedToken)}`);
        return false;
      }

      await this.router.navigate(['/login']);
    } catch {
      await this.router.navigate(['/login']);
    }

    return false;
  }
}
